import {
  ParseEmailResponse,
  SaveDisplayedPricesRequest,
  SmartQuotePromptsResponse,
} from 'apiConnector/smart-quote/model';
import { ProductVariationBase } from 'models/productsReferential';
import { map, type Observable } from 'rxjs';
import type { IHttpClient } from 'utils/http/httpClient.model';

export interface SmartQuoteApi {
  parseEmail(tabId: string, request: FormData): Observable<ParseEmailResponse>;
  fetchPrompts(tabId: string): Observable<SmartQuotePromptsResponse>;
  fetchProducts(): Observable<ProductVariationBase[]>;
  saveDisplayedPrices(request: SaveDisplayedPricesRequest): Observable<void>;
}

export function smartQuoteApiConnector(httpClient: IHttpClient): SmartQuoteApi {
  return {
    parseEmail: (tabId, req) => {
      return httpClient
        .postJSON<ParseEmailResponse>({
          url: `api/v1/smart-quotes/${tabId}`,
          body: req,
          timeOut: 10_000,
          tryParseErrorPayload: true,
        })
        .pipe(map(({ payload }) => payload));
    },
    fetchPrompts: tabId => {
      return httpClient
        .getJSON<SmartQuotePromptsResponse>({
          url: `api/v1/tab-content/smart-quote/${tabId}/prompts`,
          timeOut: 10_000,
          tryParseErrorPayload: true,
        })
        .pipe(map(({ payload }) => payload));
    },
    fetchProducts: () => {
      return httpClient
        .getJSON<ProductVariationBase[]>({
          url: `api/v1/smart-quotes/products`,
          timeOut: 10_000,
          tryParseErrorPayload: true,
        })
        .pipe(map(({ payload }) => payload));
    },
    saveDisplayedPrices: req => {
      return httpClient
        .postJSON<void>({
          url: `api/v1/smart-quotes/displayed-prices`,
          body: req,
          timeOut: 10_000,
          tryParseErrorPayload: true,
        })
        .pipe(map(({ payload }) => payload));
    },
  };
}
